import React, { useState } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Header from "./components/HeaderThree";
import IntroOverlay from "./components/IntroOverlay";

import ScrollToTop from "./components/ScrollToTop";
import Footer from "./components/Footer3";
import DisclaimerPopup from "./components/DisclaimerPopup";
import SeoManager from "./components/SeoManager";

// Pages 
import Home from "./pages/Home";
import AboutPage from "./pages/AboutUsPage";
import ProjectUspage from "./pages/ProjectUspage";
import ContactUs from "./pages/ContactUsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";

// Project Page 
import SereneSite from "./pages/SereneSite";
import PalmsSite from "./pages/PalmsSite";
import MeadowsSite from "./pages/MeadowsSite";
import WoodsSite from "./pages/WoodsSite";
import VillasSite from "./pages/VillasSite";
import UpcomingProjectPage from "./pages/UpcomingProjectPage";
import MokhilaLogo from "./assets/images/mokila-logo.png";
import KarimnagarLogo from "./assets/images/karimnagar-logo.png";
import KismathpurLogo from "./assets/images/kismathpur-logo.png";
import NarsingiLogo from "./assets/images/narsingi-logo.png";
import UpcomingBg from "./assets/images/bg-min.jpg";
import CyberMeadows from "./pages/CyberMeadows";



import "./styles/style.css";

function App() {
  const [showIntro, setShowIntro] = useState(true);

  return (
    <BrowserRouter>
      <SeoManager />

      {showIntro && (
        <IntroOverlay onFinish={() => setShowIntro(false)} />
      )}

      {!showIntro && (
        <>
          <ScrollToTop />

          {/* <Header /> */}

          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/serene" element={<SereneSite />} />
            <Route path="/palms" element={<PalmsSite />} />
            <Route path="/meadows" element={<MeadowsSite />} />
            <Route path="/woods" element={<WoodsSite />} />
            <Route path="/villas" element={<VillasSite />} />
            <Route path="/cyber-meadows" element={<CyberMeadows />} />
            <Route
              path="/mokhila"
              element={(
                <UpcomingProjectPage
                  title="Mokhila"
                  logo={MokhilaLogo}
                  backgroundImage={UpcomingBg}
                />
              )}
            />
            <Route
              path="/mokilla"
              element={<Navigate to="/mokhila" replace />}
            />
            <Route
              path="/karimnagar"
              element={(
                <UpcomingProjectPage
                  title="Karimnagar"
                  logo={KarimnagarLogo}
                  backgroundImage={UpcomingBg}
                />
              )}
            />
            <Route
              path="/kismathpur"
              element={(
                <UpcomingProjectPage
                  title="Kismathpur"
                  logo={KismathpurLogo}
                  backgroundImage={UpcomingBg}
                />
              )}
            />
            <Route
              path="/kishmathpur"
              element={<Navigate to="/kismathpur" replace />}
            />
            <Route
              path="/narsingi"
              element={(
                <UpcomingProjectPage
                  title="Narsingi"
                  logo={NarsingiLogo}
                  backgroundImage={UpcomingBg}
                />
              )}
            />
            <Route path="/about-us" element={<AboutPage />} />
            <Route path="/projects" element={<ProjectUspage />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          </Routes>

          <DisclaimerPopup />
          <ScrollToTop />
          <Footer />
        </>
      )}
    </BrowserRouter>
  );
}


export default App;
